<template>
  <div id="app-container">
    <div class="login">
      <img
        style="position: absolute; top: 50px; width: 400px; left: 50px"
        src="@/assets/images/logo.png"
      />
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
      >
        <h3 class="title">SIGN IN</h3>
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            type="text"
            auto-complete="off"
            placeholder="账号"
            prefix-icon="el-icon-user-solid"
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            auto-complete="off"
            placeholder="密码"
            @keyup.enter.native="handleLogin"
            prefix-icon="el-icon-lock"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input
            v-model="loginForm.code"
            auto-complete="off"
            placeholder="验证码"
            style="width: 67%"
            @keyup.enter.native="handleLogin"
            prefix-icon="el-icon-view"
          >
          </el-input>
          <div style="float: right">
            <img :src="codeUrl" @click="getCode" height="36" />
          </div>
        </el-form-item>
        <el-form-item style="width: 100%">
          <el-button
            :loading="loading"
            size="medium"
            type="primary"
            style="
              width: 100%;
              height: 50px;
              border-color: #3b5bc5;
              background-color: #3b5bc5;
              font-size: 18px;
            "
            @click.native.prevent="handleLogin"
          >
            <span v-if="!loading">登 录</span>
            <span v-else>登 录 中...</span>
          </el-button>
        </el-form-item>
      </el-form>
      <div
        style="
          font-weight: 600;
          color: #d0d2e1;
          letter-spacing: 0.3em;
          text-align: center;
        "
      >
        欢迎进入朗道公司后台管理系统
      </div>
      <!--  底部  -->
    </div>
    <div class="el-login-footer">
      <span>Copyright © 2020-2021 randore All Rights Reserved.</span>
    </div>
  </div>
</template>

<script>
import { getCodeImg, login } from "@/api/login";
import { setToken } from "@/utils/auth";

export default {
  name: "App",
  components: {},
  data: function () {
    return {
      codeUrl: "",
      loginForm: {
        username: null,
        password: null,
        rememberMe: false,
        code: "",
        uuid: "",
      },
      loginRules: {
        username: [
          {
            required: true,
            trigger: "blur",
            message: "用户名不能为空",
          },
        ],
        password: [
          {
            required: true,
            trigger: "blur",
            message: "密码不能为空",
          },
        ],
        code: [
          {
            required: true,
            trigger: "change",
            message: "验证码不能为空",
          },
        ],
      },
      loading: false,
      ReturnUrl: null,
    };
  },
  mounted() {},
  created() {
    this.getCode();
    var query = this.$route.query;
    this.ReturnUrl = query.ReturnUrl;
  },
  methods: {
    getCode() {
      getCodeImg().then((res) => {
        this.codeUrl = "data:image/gif;base64," + res.img;
        this.loginForm.uuid = res.uuid;
      });
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          login(
            this.loginForm.username,
            this.loginForm.password,
            this.loginForm.code,
            this.loginForm.uuid
          )
            .then((res) => {
              if (res.token) {
                setToken(res.token);
                if (this.ReturnUrl) {
                  document.location.href = this.ReturnUrl;
                } else {
                  this.$router.push({ path: "/index" });
                }
              }
            })
            .catch(() => {
              this.loading = false;
              this.getCode();
            });
        }
      });
    },
  },
};
</script>

<style>
body {
  background-image: url("../assets/images/login-background.jpg");
  background-size: cover;
  padding: 0;
  margin: 0;
}

#app-container {
  display: flex;
  position: absolute;
  align-items: center;
  width: 100%;
  height: 100%;
}

.login {
  margin: 0 auto;
}

.login-form {
  background-image: url(data:image/png;base64,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);
  background-size: contain;
  background-repeat: no-repeat;
  width: 400px;
  height: 450px;
  padding: 40px 30px 0 30px;
}

.title {
  text-align: center;
  font-size: 30px;
  font-family: Arial;
  font-weight: 700;
  color: #3b5bc5;
}
.el-login-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}
</style>
